import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { first, last } from 'underscore';
import { FormIdentifier } from '../../project/models/form-identifier.model';
import { FormShareService } from '../services/share.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class FormResolver implements Resolve<FormIdentifier> {

  constructor(
    private formService: FormShareService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FormIdentifier> {
    const formIndex = route.params['index'] || route.parent.params['index'];
    this.formService.formId = <FormIdentifier>{
      formIndex: formIndex ? parseInt(formIndex, 10) : null,
      formType: first(last(state.url.split('/')).split('?')),
      // Ensure the id of the project exists. A recent refactor for applicant routing made
      // :id no longer a param of each form route so it belongs to a parent route.
      projectGuid: route.params['id'] || route.parent.params['id']
    };

    return of(this.formService.formId);
  }
}
